import type { UpdateRequestProjectResponseType } from "@nlc/shared-types";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { requestKeys } from "@/hooks/queryKeys.ts";
import apiClient from "@/lib/api/client.ts";

export function useUpdateAccountModal() {
  const queryClient = useQueryClient();

  return useMutation<
    UpdateRequestProjectResponseType,
    Error,
    { projectId: number; requestId: number }
  >({
    mutationFn: async ({ projectId, requestId }) =>
      await apiClient
        .url("/requests/update-project")
        .post({ projectId, requestId })
        .json(),
    onError: (error) => {
      toast.add({
        description: error.message,
        timeout: 2000,
        title: "Error updating project",
        type: "error",
      });
    },
    onSuccess: (_, { requestId }) => {
      queryClient.invalidateQueries({
        queryKey: requestKeys.requestById(requestId),
      });
      toast.add({
        description: "The project has been updated successfully",
        timeout: 2000,
        title: "Project updated successfully",
        type: "success",
      });
    },
  });
}
